import {
  ADD_COURSE,
  ADD_MODULE_SHOW,
  STEPPER_NEXT,
  ADD_COURSE_RESET,
  ADD_MODULE,
  ADD_MODULE_RESET,
  PLAY_VIDEO,
  PERCENT_AGE,
  STEPPER_COHORT,
  STEPPER_COURSES,
  JUMP_PAGE,
  COURSEID,
  UPDATE_PREV_TAG_STATE,
  GetFilteredData,
  isPodcastView,
  isAssignLearnerStep,
  isSeatingCapacityFull,
  masterCourseID,
  isClonedCourse,
  Nomination_EndDate,
  courseStartDate,
  classroomTimings,
  getPreviousBatchEmployees,
  SET_SELECTED_EMPLOYEES,
  userRoleAccess,
  lmsReqApprove,
  reassignCoordinator,
  superAdminUserName,
  nominatedCourseID,
  iseditClonedCourse,
} from "redux/constants/AppConstants";

const INITIAL_STATE = {
  addCourse: [],
  addModule: [],
  addModuleState: true,
  stepActive: 0,
  videoStemp: true,
  percentage: 0,
  stepCohort: "1",
  setCourses: "1",
  jumpPage: 3,
  CourseId: null,
  prevTagState: {},
  filterdata: [],
  isPodVieew: false,
  isAssignLearner: 1,
  seatingCapacityFull: false,
  mastercourseID: "",
  isclonedcourse: false,
  nominationenddate: "",
  course_StartDate: "",
  classroom_Timings: "",
  get_PreviousBatchEmployees: false,
  selectedEmployees: [],
  user_RoleAccess: "",
  lms_ReqApprove: "",
  reassign_Coordinator: "",
  super_AdminUserName: "",
  nominated_CourseID:"",
  isedit_ClonedCourse: true,
};

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_COURSE:
      return { ...state, addCourse: [action.payload] };
    case ADD_MODULE:
      return { ...state, addModule: [...state.addModule, action.payload] };
    case ADD_COURSE_RESET:
      return { ...state, addCourse: action.payload };
    case ADD_MODULE_RESET:
      return { ...state, addModule: action.payload };
    case ADD_MODULE_SHOW:
      return { ...state, addModuleState: action.payload };
    case STEPPER_NEXT:
      return { ...state, stepActive: action.payload };
    case PLAY_VIDEO:
      return { ...state, videoStemp: action.payload };
    case PERCENT_AGE:
      return { ...state, percentage: action.payload };
    case STEPPER_COHORT:
      return { ...state, stepCohort: action.payload };
    case STEPPER_COURSES:
      return { ...state, setCourses: action.payload };
    case JUMP_PAGE:
      return { ...state, jumpPage: action.payload };
    case COURSEID:
      return { ...state, CourseId: action.payload };
    case UPDATE_PREV_TAG_STATE:
      return { ...state, prevTagState: action.payload };
    case GetFilteredData:
      return { ...state, filterdata: action.payload };
    case isPodcastView:
      return { ...state, isPodVieew: action.payload };
    case isAssignLearnerStep:
      return { ...state, isAssignLearner: action.payload };
    case isSeatingCapacityFull:
      return { ...state, seatingCapacityFull: action.payload };
    case masterCourseID:
      return { ...state, mastercourseID: action.payload };
    case isClonedCourse:
      return { ...state, isclonedcourse: action.payload };
    case Nomination_EndDate:
      return { ...state, nominationenddate: action.payload };
    case courseStartDate:
      return { ...state, course_StartDate: action.payload };
    case classroomTimings:
      return { ...state, classroom_Timings: action.payload };
    case getPreviousBatchEmployees:
      return { ...state, get_PreviousBatchEmployees: action.payload };
    case SET_SELECTED_EMPLOYEES:
      return { ...state, selectedEmployees: action.payload };
    case userRoleAccess:
      return { ...state, user_RoleAccess: action.payload };
    case lmsReqApprove:
      return { ...state, lms_ReqApprove: action.payload };
    case reassignCoordinator:
      return { ...state, reassign_Coordinator: action.payload };
    case superAdminUserName:
      return { ...state, super_AdminUserName: action.payload };
    case nominatedCourseID:
      return { ...state, nominated_CourseID: action.payload }; 
    case iseditClonedCourse:
      return {...state, isedit_ClonedCourse: action.payload};
    default:
      return state;
  }
};

export default userReducer;
